module.exports = __webpack_public_path__ + "static/images/kaiping1_572272b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/kaiping1.png
// module id = 239
// module chunks = 1